import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px 8px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding: 18px 24px;
  }
`;
